export default __webpack_public_path__ + "static/driver-behavior-monitoring-396603f833f535b98b34d9b3b8b4f3ac.png";